import { WinSpinePopup } from "./WinSpinePopup";

export class FreeSpinIntroPopup extends WinSpinePopup {
    constructor({ freeSpins = {lef: 0}, ...parameters }) {
        super({
            ...parameters,
            spine: "freeSpinIntro",
            win: freeSpins.left,
            isCounter:false,
            sequence: [
                { animation: "in", sfx: { name: "fs_award_popup" } },
                { animation: "loop", loop: 3},
                { animation: "out" },
            ],
            skipByClick: true,
        });
    }
}
